import z from 'zod'

export const ssoLoginSchema = z.object({
  email: z.email()
})
